import { useToast } from 'context/tostifyContext';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import customAxios from 'routes/Pages/util/Api';
import authHeader from 'services/auth/jwt/auth-header';
import { FETCH_ERROR, FETCH_START, FETCH_SUCCESS } from '../../constants/ActionTypes';
import { useAllUsers } from 'context/AllUserDataContext';

const useManagingStoresController = () => {
  const dispatch = useDispatch();

  const isMounted = useRef(true);
  const { getAllUsers, allUsers } = useAllUsers();
  const { showToast } = useToast();

  const [poData, setPoData] = useState([]);
  const [stockTransaction, setStockTransactions] = useState([]);
  const [viewTransactionDialog, setViewTransactionDialog] = useState(false);

  const [viewFormDialog, setViewFormDialog] = useState(false);
  const [currentData, setCurrentData] = useState({});

  useEffect(() => {
    isMounted.current = true;
    getStockData();
    getAllUsers();
    return () => {
      isMounted.current = false; // Set to false on unmount
    };
  }, []);

  const getStockData = () => {
    dispatch({ type: FETCH_START });
    customAxios
      .get('/PO/GetStockData', { headers: authHeader() })
      .then(data => {
        if (data.status == 200) {
          const sortedData = data.data.sort((a, b) => b.id - a.id);
          setPoData(sortedData);
        } else {
          showToast('Failed to load stock Data ', 'error');
        }
        dispatch({ type: FETCH_SUCCESS });
      })
      .catch(error => {
        // showToast('Failed to Add New Purchase Requisition ', 'error');
        dispatch({ type: FETCH_ERROR, payload: 'Network Error' });
      });
  };

  const OpenViewTransactionDialog = data => {
    dispatch({ type: FETCH_START });
    customAxios
      .get(`/PO/GetStockTransactions/${data.ordeR_NUMBER}`, { headers: authHeader() })
      .then(data => {
        if (data.status == 200) {
          const sortedData = data.data.sort((a, b) => b.id - a.id);
          setStockTransactions(sortedData);
          setViewTransactionDialog(true);
        } else {
          showToast('Failed to load stock transaction Data ', 'error');
        }
        dispatch({ type: FETCH_SUCCESS });
      })
      .catch(error => {
        // showToast('Failed to Add New Purchase Requisition ', 'error');
        dispatch({ type: FETCH_ERROR, payload: 'Network Error' });
      });
  };

  const handleDialogClose = () => setViewTransactionDialog(false);
  const handleAddDialogClose = () => setViewFormDialog(false);

  const handleConsume = async data => {
    console.log('data ===', data);
    setCurrentData(data);
    dispatch({ type: FETCH_START });
    customAxios
      .get(`/PO/GetStockTransactions/${data.ordeR_NUMBER}/${data.stocK_CODE}`, { headers: authHeader() })
      .then(data => {
        if (data.status == 200) {
          const sortedData = data.data.sort((a, b) => b.id - a.id);
          setStockTransactions(sortedData);

          viewFormDialog === false && setViewFormDialog(true);
        } else {
          showToast('Failed to load stock transaction Data ', 'error');
        }
        dispatch({ type: FETCH_SUCCESS });
      })
      .catch(error => {
        // showToast('Failed to Add New Purchase Requisition ', 'error');
        dispatch({ type: FETCH_ERROR, payload: 'Network Error' });
      });
  };

  return {
    poData,
    OpenViewTransactionDialog,
    stockTransaction,
    viewTransactionDialog,
    handleDialogClose,
    handleConsume,
    viewFormDialog,
    handleAddDialogClose,
    currentData,
  };
};

export default useManagingStoresController;
